import React from 'react'
import { Nav } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'
import { CAMPAIGN_MESSAGES as M } from '../campaignMessages'
import './CampaignsNav.css'

export const CampaignsNav: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname.startsWith(path)
  }

  return (
    <Nav variant='tabs' className='campaigns-nav mb-4'>
      <Nav.Item>
        <Nav.Link
          active={isActive('/campaigns') && !location.pathname.includes('/templates') && !location.pathname.includes('/recipients')}
          onClick={() => navigate('/campaigns')}
          style={{ cursor: 'pointer' }}
        >
          <i className='bi bi-megaphone me-2'></i>
          <FormattedMessage {...M.navCampaigns} />
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          active={isActive('/campaigns/templates') || isActive('/templates')}
          onClick={() => navigate('/campaigns/templates')}
          style={{ cursor: 'pointer' }}
        >
          <i className='bi bi-file-text me-2'></i>
          <FormattedMessage {...M.navTemplates} />
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          active={isActive('/automations')}
          onClick={() => navigate('/automations')}
          style={{ cursor: 'pointer' }}
        >
          <i className='bi bi-lightning-charge me-2'></i>
          <FormattedMessage {...M.navAutomations} />
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          active={isActive('/campaigns/recipients') || isActive('/recipients')}
          onClick={() => navigate('/recipients')}
          style={{ cursor: 'pointer' }}
        >
          <i className='bi bi-people me-2'></i>
          <FormattedMessage {...M.navRecipients} />
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          active={isActive('/vicidial-campaigns')}
          onClick={() => navigate('/vicidial-campaigns')}
          style={{ cursor: 'pointer' }}
        >
          <i className='bi bi-telephone-outbound me-2'></i>
          <FormattedMessage {...M.navDialer} />
        </Nav.Link>
      </Nav.Item>
    </Nav>
  )
}
